import { Controller } from '@hotwired/stimulus';

// Fires a configurable window CustomEvent on action, so a trigger can open a
// component that lives elsewhere in the DOM (e.g. a kebab item → config modal).
// Usage: data-controller="dispatch" data-dispatch-event-value="config:open"
//        data-action="dispatch#fire"
export default class extends Controller {
  static values = { event: String };

  fire() {
    if (this.eventValue) window.dispatchEvent(new CustomEvent(this.eventValue));
  }
}
